export default "__VITE_ASSET__ConGudaB__"